import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useAppDispatch, useAppSelector } from 'redux-store';
import { goNext } from 'redux-store/slices/survey';

import logEvent, { setUserPropertyAmplitude } from 'analytics/logEvent';

import SurveyPage from 'components/pagesComponents/survey/SurveyV30Page';
import SurveyImage from 'components/domains/survey/SurveyImage';
import FadeOut from 'components/domains/survey/FadeOut';

import surveyPageProps from 'utils/surveyPageProps';

import styles from './styles.module.scss';

export default function Welcome() {

  const router = useRouter();
  
  const dispatch = useAppDispatch();
  const nextPageUrl = useAppSelector((state) => state.onboarding.nextPageUrl);

  useEffect(() => {
    const delay = 2000;

    const redirectTimeout = setTimeout(() => {

      dispatch(goNext());
      router.push(nextPageUrl);
    }, delay);

    return () => {
      clearTimeout(redirectTimeout);
    };
  }, [nextPageUrl]);

  useEffect(() => {
    logEvent('Web_Survey_Started');

    const { pathname, query } = router;
    const paths = pathname.split('/');
    if (paths?.[2]) {
      setUserPropertyAmplitude('web_onboarding_ver', paths[2]);
    }
    
    if (query.utm_campaign) {
      setUserPropertyAmplitude('utm_campaign', query.utm_campaign as string);
    }
  }, []);

  return (
    <SurveyPage
      isAvailabelHeader={false}
      isAvailabelNextButton={false}
      isAvailabelBackButton={false}
      showTerms={false}
    >
      <FadeOut>
        <SurveyImage
          className={styles.welcomeImage}
          src={`/pagesImages/survey/welcome-dark.png`}
          width={572}
          height={392}
        />
      </FadeOut>
    </SurveyPage>
  );
}

export const getServerSideProps = surveyPageProps;